import React from 'react';
import { TextField } from '@mui/material';
import { errorTextHelper, inputStyle } from './style';

function TextInput(props) {
  const { type, errortext } = props;

  return (
    <TextField
      {...props}
      FormHelperTextProps={{
        style: {
          ...errorTextHelper,
        },
      }}
      InputLabelProps={{
        ...((type === 'date' || type === 'time') && {
          shrink: true,
        }),
      }}
      InputProps={{
        style: {
          ...inputStyle,
        },
      }}
      {...(errortext && {
        error: true,
        helperText: errortext,
      })}
    />
  );
}

export default TextInput;
